import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class UserService {

    appUrl = "";
    apiUrlLogin=""
    appOrgUrl = "";
    appOrgUrlconfig= "";
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient) {
        this.appUrl = environment.localApiUrl;
        this.apiUrlLogin = environment.apiUrlLogin;
        this.appOrgUrl = environment.appOrgUrl;
        this.appOrgUrlconfig = environment.appOrgUrlconfig;
    }


    getUsers(organizationId) {
        return this.http.get<any>(`${this.appOrgUrl}User?organizationId=${organizationId}&includeDeleted=false&inActive=false&both=true`)
            .toPromise()
            .then(res => res);
    }

    getUsersWithName() {
        return this.http.get<any>(`${this.appOrgUrl}User/UsersWithName`)
            .toPromise()
            .then(res => res);
    }

    getUsersBirthdays(organizationId) {
        return this.http.get<any>(`${this.appOrgUrlconfig}User/UpcomingBirthdays`)
            .toPromise()
            .then(res => res);
    }

    getAllUserGroup() {
        return this.http.get<any>(`${this.appOrgUrl}UserGroup?groupId=0`)
        //return this.http.get<any>(`${this.apiUrlLogin}/UserGroup?groupId=0`)
            .toPromise()
            .then(res => res);
    }

    getUserRoles() {
        return this.http.get<any>(this.appUrl + 'userRoles')
            .toPromise()
            .then(res => res);
    }

    getAvailableMenus() {
        return this.http.get<any>(this.appUrl + 'availableMenus')
            .toPromise()
            .then(res => res);
    }

    getAvailableDashboardWidgets() {
        return this.http.get<any>(this.appUrl + 'dashboardWidgets')
            .toPromise()
            .then(res => res);
    }

    updateUser(user) {
        return this.http.put(this.appUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    getLoggedUser(userId) {
        //return this.http.get<any>(this.appOrgUrl + 'User/GetUserById/' + userId)
        return this.http.get<any>(this.appUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    getAddressByLatLng(lat,lng) {
        return this.http.get<any>(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU`)
            .toPromise()
            .then((res) => {
                return res
            }
        );
    }

    saveCookies(isCookieEnable: boolean){
        return this.http.post(`${this.appOrgUrl}UserPreference/UserAcceptance?acceptance=${isCookieEnable}`,{});
    }
}
